import dynamic from 'next/dynamic'
import { BlockProps } from '../BlockProps'
import { ISpecialistColumnsBlockData } from './ISpecialistColumnsBlockData'
import { TServerSideSpecialistColumnsBlockProps } from './TServerSideSpecialistColumnsBlockProps'

export const DynamicSpecialistColumnsBlock = dynamic<
  BlockProps<
    ISpecialistColumnsBlockData,
    TServerSideSpecialistColumnsBlockProps
  >
>(() =>
  import('./SpecialistColumnsBlock').then((md) => md.SpecialistColumnsBlock)
)
